module.exports = __webpack_public_path__ + "img/a29b4da.jpg";